<template>
  <v-row style="display: flex; justify-content: space-between">
    <v-col cols="12" sm="6" md="4" class="date d-flex align-center">
      <span class="mr-1">entrada</span>
      <v-icon @click="changeDateBy('dateFrom', 'yesterday')" class="mr-1">
        fa-angle-left
      </v-icon>
      <v-text-field
        v-model="formattedDateFrom"
        hide-details
        class="inputDate"
        placeholder="dd/mm/yyyy"
        dense
        flat
        solo
        maxlength="10"
        v-mask="'##/##/####'"
        @blur="onManualDateFromChange"
      />
      <v-menu
        ref="menuFrom"
        v-model="menuFrom"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-icon class="mr-1" small v-bind="attrs" v-on="on">
            far fa-calendar
          </v-icon>
        </template>

        <v-date-picker
          v-model="dateFrom"
          @input="onDateFromChange"
          @change="menuFrom = false"
          locale="es"
        />
      </v-menu>
      <v-icon @click="changeDateBy('dateFrom', 'laterday')" class="ml-1">
        fa-angle-right
      </v-icon>
    </v-col>

    <v-col cols="12" sm="6" md="4" class="date ml-2 d-flex align-center">
      <span class="mr-1">salida</span>
      <v-icon
        @click="changeDateBy('dateTo', 'yesterday')"
        class="mr-1"
        :disabled="checkTo"
      >
        fa-angle-left
      </v-icon>
      <v-text-field
        v-model="formattedDateTo"
        hide-details
        class="inputDate"
        placeholder="dd/mm/yyyy"
        dense
        flat
        solo
        maxlength="10"
        v-mask="'##/##/####'"
        :disabled="checkTo"
        @blur="onManualDateToChange"
      />
      <v-menu
        ref="menuTo"
        v-model="menuTo"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-icon
            class="mr-1"
            small
            v-bind="attrs"
            v-on="on"
            :disabled="checkTo"
          >
            far fa-calendar
          </v-icon>
        </template>

        <v-date-picker
          v-model="dateTo"
          @input="onDateToChange"
          @change="menuTo = false"
          locale="es"
        />
      </v-menu>

      <v-icon
        @click="changeDateBy('dateTo', 'laterday')"
        class="ml-1"
        :disabled="checkTo"
      >
        fa-angle-right
      </v-icon>
    </v-col>

    <v-tooltip right>
      <template v-slot:activator="{ on }">
        <span v-on="on">
          <v-simple-checkbox
            v-show="!showCheck"
            :ripple="false"
            color="accent"
            class="my-2 ml-1"
            v-model="checkTo"
          ></v-simple-checkbox>
        </span>
      </template>
      <span>{{ $tc("changeSchedule.caducity") }}</span>
    </v-tooltip>
  </v-row>
</template>

<script>
import moment from "moment";

export default {
  props: {
    showCheck: { type: Boolean, default: false },
  },
  data() {
    return {
      menuTo: false,
      menuFrom: false,
    };
  },
  computed: {
    dateFrom: {
      get() {
        const date = this.$store.state.gestionTiempos.dateFromComponents;
        return date && moment(date, "YYYY-MM-DD", true).isValid() ? date : null;
      },
      set(date) {
        this.setDate(date);
      },
    },
    dateTo: {
      get() {
        const date = this.$store.state.gestionTiempos.dateToComponents;
        return date && moment(date, "YYYY-MM-DD", true).isValid() ? date : null;
      },
      set(value) {
        this.setDateTo(value);
      },
    },
    checkTo: {
      get() {
        return this.$store.state.gestionTiempos.checkTo;
      },
      set(newValue) {
        this.setCheckTo(newValue);
      },
    },
    formattedDateFrom: {
      get() {
        if (!this.dateFrom) return null;
        const m = moment(this.dateFrom, "YYYY-MM-DD", true);
        return m.isValid() ? m.format("DD/MM/YYYY") : "";
      },
      set(value) {
        const parsed = moment(value, "DD/MM/YYYY", true);
        if (parsed.isValid()) {
          this.dateFrom = parsed.format("YYYY-MM-DD");
        }
      },
    },
    formattedDateTo: {
      get() {
        if (!this.dateTo) return null;
        const m = moment(this.dateTo, "YYYY-MM-DD", true);
        return m.isValid() ? m.format("DD/MM/YYYY") : "";
      },
      set(value) {
        const parsed = moment(value, "DD/MM/YYYY", true);
        if (parsed.isValid()) {
          this.dateTo = parsed.format("YYYY-MM-DD");
        }
      },
    },
  },

  methods: {
    onDateFromChange(date) {
      if (!moment(date, "YYYY-MM-DD", true).isValid()) return;
      this.dateFrom = date;
    },
    onManualDateFromChange() {
      const [d, m, y] = this.formattedDateFrom.split("/");
      const parsed = `${y}-${m}-${d}`;
      if (moment(parsed, "YYYY-MM-DD", true).isValid())
        this.onDateFromChange(parsed);
    },
    onDateToChange(date) {
      if (!moment(date, "YYYY-MM-DD", true).isValid()) return;
      this.dateTo = date;
    },
    onManualDateToChange() {
      const [d, m, y] = this.formattedDateTo.split("/");
      const parsed = `${y}-${m}-${d}`;
      if (moment(parsed, "YYYY-MM-DD", true).isValid())
        this.onDateToChange(parsed);
    },
    changeDateBy(model, action) {
      const actual = this[model];
      let newDate = moment(actual);
      newDate =
        action === "yesterday"
          ? newDate.subtract(1, "days")
          : newDate.add(1, "days");
      const formatted = newDate.format("YYYY-MM-DD");
      model === "dateFrom"
        ? this.onDateFromChange(formatted)
        : this.onDateToChange(formatted);
    },
    setDate(date) {
      this.$store.commit("gestionTiempos/setDateFromComponents", date);
    },
    setDateTo(date) {
      this.$store.commit("gestionTiempos/setDateToComponents", date);
    },
    setCheckTo(value) {
      this.$store.commit("gestionTiempos/setCheckTo", value);
    },
  },
};
</script>

<style scoped>
.inputDate {
  font-size: 16px !important;
  width: 112px;
}
.date {
  max-width: 250px !important;
  display: flex;
  align-items: center !important;
  max-height: 40px !important;
  border: 1px solid #ccc;
  border-radius: 5px !important;
  background-color: white;
}
</style>
